export default {
  mediaSaturation: 'Media Saturation (%)'
}
